module.exports = __webpack_public_path__ + "img/2-4.1a32211b.jpg";